export default function ConfirmModal({ credits, onConfirm, onCancel, type }) {

  if (type === 'delete') return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
      <div style={{ background: '#ffffff', borderRadius: 12, overflow: 'hidden', border: '1px solid #111111', padding: 24, width: 300, textAlign: 'center', fontFamily: "'DM Mono', monospace" }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#111111', marginBottom: 10, letterSpacing: 0.5 }}>정말 탈퇴하시겠어요?</div>
        <div style={{ fontSize: 13, color: '#888888', lineHeight: 1.8, marginBottom: 20 }}>
          탈퇴하면 아래 데이터가 모두 삭제돼요.<br/>
          <span style={{ color: '#111111', fontWeight: 600 }}>변환 기록 · 즐겨찾기 · 남은 말풍선</span><br/>
          삭제된 데이터는 복구할 수 없어요.
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={onCancel}
            style={{ flex: 1, padding: 11, background: '#ffffff', color: '#111111', border: '1px solid #111111', borderRadius: 8, fontSize: 15, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
            취소
          </button>
          <button onClick={onConfirm}
            style={{ flex: 1, padding: 11, background: '#111111', color: '#ffffff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
            탈퇴하기
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
      <div style={{ background: '#ffffff', borderRadius: 12, overflow: 'hidden', border: '1px solid #111111', padding: 20, width: 280, textAlign: 'center', fontFamily: "'DM Mono', monospace" }}>
        <div style={{ fontSize: 22, marginBottom: 8 }}>💬</div>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#111111', marginBottom: 4 }}>
          {credits <= 1 ? '마지막 말풍선이에요' : '말풍선 1개를 사용할게요'}
        </div>
        <div style={{ fontSize: 13, color: '#888888', marginBottom: 16 }}>
          {credits <= 1
            ? '사용하면 0개가 돼요. 충전은 마이페이지에서 할 수 있어요.'
            : `남은 말풍선 ${credits}개 → ${credits - 1}개`}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={onCancel}
            style={{ flex: 1, padding: 10, background: '#ffffff', color: '#111111', border: '1px solid #111111', borderRadius: 8, fontSize: 15, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
            취소
          </button>
          <button onClick={onConfirm}
            style={{ flex: 1, padding: 10, background: '#111111', color: '#ffffff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
}